import { jsx } from 'react/jsx-runtime';
import rehypeRaw from 'rehype-raw';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';
import { makeStyles } from 'tss-react/mui';
import '@mui/material';
import { useContext } from 'react';
import { AuthContext } from '@plumeuk/shapeshift-identity';
import 'x2js';

//Hook returns url path to server resources
//With strapi local dev path is relative
function useFileBaseUrl() {
    const { config } = useContext(AuthContext);
    const baseFileUrl = process.env.NODE_ENV === "production" ? "" : (config?.baseApiUrl ?? "");
    const getUrl = (e) => {
        if (e.startsWith("http"))
            return e;
        return baseFileUrl + e;
    };
    return { baseFileUrl, getUrl };
}

/* eslint-disable no-console */
console.log.bind(null) ;
console.warn.bind(null) ;
console.error.bind(null) ;

const useStyles = makeStyles()((_theme) => ({
    wysiwyg: {
        "& img": {
            maxWidth: "100%"
        }
    }
}));
const WYSIWYG = ({ className, ...props }) => {
    const { classes, cx } = useStyles();
    const { getUrl } = useFileBaseUrl();
    return (jsx(ReactMarkdown, { className: cx(classes.wysiwyg, className), rehypePlugins: [rehypeRaw], components: {
            u: (uProps) => jsx("u", { style: { textDecoration: "underline" }, ...uProps }),
            a: (aProps) => jsx("a", { ...aProps, href: (!aProps.href || aProps?.href.includes("http")) ? aProps.href : ("https://" + aProps.href) }),
            img: ({ src, ...imgProps }) => jsx("img", { src: getUrl(src ?? ""), ...imgProps })
        }, ...props }));
};

export { WYSIWYG };
